import { Button, Column, Icon, Loader, Row, Text } from "@amzn/meridian";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import HistoryInspectionCard from "../configurationDrivenInspections/HistoryInspectionCard";
import { useAppSelector, useAppDispatch } from "src/store/store";
import { getSiteInspectionHistory } from "src/store/inspectionSlice";
import { InspectionListView } from "src/services/inspectionService";

const CompletedInspections = () => {
  // Site-scoped: reflects the currently selected site's completed inspections
  // across all inspectors, not just the current user's own.
  const { completedSiteInspections, getSiteInspectionHistoryLoading, getSiteInspectionHistoryError } =
    useAppSelector((state) => state.inspection);
  const activeSiteCode = useAppSelector((state) => state.user.activeSiteCode);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // This route can be reached directly (deep link, refresh) without HistoryView
  // ever having run, so fetch here rather than relying on another screen's fetch.
  const fetchHistory = () => {
    if (!activeSiteCode) return;
    dispatch(getSiteInspectionHistory(activeSiteCode));
  };

  useEffect(() => {
    fetchHistory();
  }, [activeSiteCode, dispatch]);

  const handleCardClick = (inspection: InspectionListView) => {
    navigate(`/configurationDrivenInspections/${inspection.inspectionId}/review`);
  };

  const isLoading = getSiteInspectionHistoryLoading === "pending";
  const isError = getSiteInspectionHistoryLoading === "rejected";

  return (
    <div className="app-gradient-bg pwa-scrollable">
      <Column spacingInset="500" spacing="400">
        <Row alignmentVertical="center" spacing="300">
          <div
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            <Icon tokens={chevronLeftLargeTokens} color="primary" />
          </div>
          <Text type="h200">Dashboard</Text>
        </Row>

        <Text type="b500">Inspection History</Text>

        {isLoading ? (
          <Row alignmentHorizontal="center" spacingInset="500">
            <Loader type="circular" size="medium" />
          </Row>
        ) : isError ? (
          <Column spacingInset="500" alignmentHorizontal="center" spacing="300">
            <Text color="error">
              {getSiteInspectionHistoryError || "Couldn't load inspection history."}
            </Text>
            <Button type="link" onClick={fetchHistory}>
              Try Again
            </Button>
          </Column>
        ) : completedSiteInspections.length > 0 ? (
          completedSiteInspections.map((inspection) => (
            <HistoryInspectionCard
              key={inspection.inspectionId}
              inspection={inspection}
              onClick={handleCardClick}
            />
          ))
        ) : (
          <Text>No completed inspections for this site.</Text>
        )}
      </Column>
    </div>
  );
};

export default CompletedInspections;
